// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import { Button } from '@chakra-ui/react';
import {
  Box,
  Center,
  Divider,
  Flex,
  Image,
  Text,
} from '@joinrepublic/dls-ui-kit';

import mirrorIcon from './assets/mirror-icon.png';
import rocket from './assets/rocket.png';

export const RSpaxBanner = ({
  onBannerClick,
}: {
  onBannerClick: () => void;
}) => {
  return (
    <Box
      as="a"
      href="/rspax-2"
      display="grid"
      rowGap="3"
      gridTemplateColumns={{ base: '1fr', sm: 'auto 1fr', md: '1fr auto 1fr' }}
      alignItems="center"
      px={{ base: '7', sm: '4' }}
      py={{ base: '3.5', sm: '3' }}
      h={{ sm: '69px' }}
      color="white"
      textAlign="center"
      overflow="hidden"
      backgroundColor="#000D1D"
      onClick={onBannerClick}
      position="relative"
      _before={{
        content: '""',
        position: 'absolute',
        width: { base: '65px', md: '88px' },
        height: { base: '65px', md: '88px' },
        bottom: { base: '-4px', md: '-16px' },
        right: { base: '0', md: 'auto' },
        left: { base: 'auto', md: '40px' },
        backgroundImage: `url(${rocket})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        transform: { base: 'rotate(0deg)', md: 'rotate(14deg)' },
        display: { sm: 'none', md: 'block' },
        pointerEvents: 'none',
      }}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        gridColumn={{ base: '1', sm: '2' }}
        flexDirection={{ base: 'column', sm: 'row' }}
        gap={{ base: '2', sm: '0' }}
        justifySelf={{ base: 'center', sm: 'start', md: 'center' }}
        position="relative"
        zIndex={1}
      >
        <Flex gap={{ base: '1', sm: '2' }} alignItems="center">
          <Image
            src={mirrorIcon}
            alt="Republic Mirror Tokens icon"
            boxSize={{ base: '4', sm: '6' }}
          />
          <Text
            as="span"
            size={{ base: 'body-sm', sm: 'body-md' }}
            color="white"
            fontWeight="medium"
          >
            Republic Mirror Tokens
          </Text>
        </Flex>
        <Center height="20px" display={{ base: 'none', sm: 'block' }}>
          <Divider mx="4" orientation="vertical" />
        </Center>
        <Box>
          <Text as="span" color="white">
            Invest in the performance of SpaceX
          </Text>
        </Box>
      </Flex>

      <Button
        as="a"
        justifySelf={{ base: 'center', sm: 'end' }}
        gridColumn={{ base: '1', sm: '3' }}
        href="/rspax-2"
        size="md"
        variant="republic-secondary"
        color="white"
        bgColor="transparent"
        fontWeight="normal"
        py="3"
        w={{ base: 'full', sm: '186px' }}
        position="relative"
        height="43px"
        zIndex="1"
        border="1px solid"
        borderColor="grey.50"
        _hover={{
          color: 'inherit',
          backgroundColor: 'whiteAlpha.300',
        }}
      >
        Learn how
      </Button>
    </Box>
  );
};
